import { RouteType } from "types/RouteType";
import type InquiryQueueStore from "./InquiryQueueStore";

const storeOf = (rootStore: unknown) =>
  (rootStore as { myQuestionsViewStore?: InquiryQueueStore }).myQuestionsViewStore;

/**
 * Clients → My questions ([hub] H3, plan/2026-10-19_FROM-GANTRY_hq-is-the-hub-contract.md):
 * the client inquiries assigned to the signed-in person — whoever owns the
 * work a question blocks — every stage, open first. A second instance of the
 * Inquiry Queue's store in `mine` mode, so answering works exactly as there;
 * the API narrows the list (`mine=true`), not this screen.
 *
 * The bell and the phone push for a new question link here, as `?open=<id>`.
 * Registered BEFORE ClientDetail in clientsRoutesList (`/clients/:id/:tab?`).
 */
const myQuestionsRoute: RouteType[] = [
  {
    name: "MyQuestions",
    path: "/clients/my-questions",
    layout: "/app",
    viewportCard: {
      header: {
        enableBackButton: true,
        title: "My questions",
        enableRefreshButton: true,
        component: () => import("./MyQuestions.Header"),
      },
      body: {
        component: () => import("./MyQuestions.Body"),
        grayBackground: true,
      },
    },
    group: "Clients",
    searchAliases: ["my questions", "questions for me", "questions assigned to me", "my inquiries"],
    requiresAuth: true,
    requiresPermission: false,
    onEnter: ({ rootStore }) => {
      const store = storeOf(rootStore);
      if (!store) return;
      store.setMine(true);
      // `?open=<id>` (the bell, a phone push) opens that question once the list is in.
      const raw = (rootStore as { routerStore?: { queryParams?: Record<string, unknown> } }).routerStore?.queryParams?.open;
      const open = Number(Array.isArray(raw) ? raw[0] : raw);
      void store.initialize().then(() => store.openById(open));
    },
    onExit: ({ rootStore }) => {
      storeOf(rootStore)?.reset();
    },
  },
];

export default myQuestionsRoute;
